import React from 'react';

import { useLocationController } from '@/controllers';
import { maxWidth, maxWidthSearch, maxWidthDashboard, marginAuto, maxWidthApp } from '@/styles';
import { FCC } from '@/utils/types';

/** Forces content to be mid-column */
const Content: FCC = props => {
  // TODO: Optimise breakpoint across the entire app e.g homepage shouldn't have
  // weird side gap on large resolution, e.g 1400px
  const {
    isSearchPage,
    isHomepage,
    isTeamPage,
    isProductPage,
    isSLOGroupPage,
  } = useLocationController();

  return (
    <div
      css={[
        // eslint-disable-next-line no-nested-ternary
        isSearchPage
          ? maxWidthSearch
          : // eslint-disable-next-line no-nested-ternary
          isHomepage || isTeamPage || isProductPage
          ? maxWidthDashboard
          : isSLOGroupPage
          ? maxWidthApp
          : maxWidth,
        marginAuto,
      ]}
      {...props}
    />
  );
};

export default Content;
